<template>
  <div class="settled-bet-card">
    <div v-bind:class="
    [{
    'settled-bet-card-status-bar--won':(betData.betStatus === 'Won' || betData.betStatus ==='HalfWon'
        || ((betData.betStatus === 'BackedDeadHeat' || betData.betStatus === 'LaidDeadHeat') && (betData.outputAmount-betData.cost >= 0))
      ),
     'settled-bet-card-status-bar--lost':(betData.betStatus === 'Lost' || betData.betStatus ==='HalfLost'
        || ((betData.betStatus === 'BackedDeadHeat' || betData.betStatus === 'LaidDeadHeat') && (betData.outputAmount-betData.cost < 0))
      ),
     'settled-bet-card-status-bar--cancelled':(betData.betStatus === 'UnmatchedCanceled'
     || betData.betStatus === 'Voided'
     || betData.betStatus ==='Refund'
     || betData.betStatus === 'UserCanceled'
     ),
     }]"
         class="settled-bet-card-status-bar"></div>
    <div class="settled-bet-card-content">
      <div class="result-wrapper">
        <div class="result-container">
          <span class="result"><span class="result-title">{{market | capitalise}}</span>{{betData.name | capitalise}}</span>
        </div>
        <div class="info-btn" @click="showInfo">
          <v-icon>krypt-info</v-icon>
        </div>
      </div>
      <div class="settled-bet-card-cells">
        <div class="settled-bet-card-cell bet-card-cell-odds">
          <div class="cell-title">
            <span>{{$t(`bets.${betData.betType}`)| removeDiacriticsFromUppercase}}</span>
          </div>
          <div class="cell-value">
            <span>{{betData.odds}}</span>
          </div>
        </div>
        <div class="settled-bet-card-cell">
          <div class="cell-title">
            <span >{{$t(`bets.stake`)| removeDiacriticsFromUppercase}}</span>
          </div>
          <div class="cell-value">
            <span>{{ betData.stake | numberWithCommasAndCurrency(this.userCurrency)}}</span>
          </div>
        </div>
        <div class="settled-bet-card-cell">
          <div v-bind:class="    [{
    'cell-title--won':(betData.betStatus === 'Won' || betData.betStatus ==='HalfWon'
        || ((betData.betStatus === 'BackedDeadHeat' || betData.betStatus === 'LaidDeadHeat') && (betData.outputAmount-betData.cost >= 0))
      ),
     'cell-title--lost':(betData.betStatus === 'Lost' || betData.betStatus ==='HalfLost'
        || ((betData.betStatus === 'BackedDeadHeat' || betData.betStatus === 'LaidDeadHeat') && (betData.outputAmount-betData.cost < 0))
      ),
     'cell-title--canceled':(betData.betStatus === 'UnmatchedCanceled'
     || betData.betStatus === 'Voided'
     || betData.betStatus ==='Refund'
     || betData.betStatus === 'UserCanceled'
     ),
     }]"
               class="cell-title">
            <span>{{$t(`bets.settledBets.betStatues.${betData.betStatus}`) | removeDiacriticsFromUppercase}}</span>
          </div>
          <div class="cell-value">
            <span v-if="betData.betStatus ==='Won' || betData.betStatus ==='HalfWon'
              || ((betData.betStatus === 'BackedDeadHeat' || betData.betStatus === 'LaidDeadHeat') && (betData.outputAmount-betData.cost >= 0))"
            >{{betData.outputAmount-betData.cost| numberWithCommasAndCurrency(this.userCurrency)}}</span>
            <span v-if="betData.betStatus ==='Lost' || betData.betStatus ==='HalfLost'
              || ((betData.betStatus === 'BackedDeadHeat' || betData.betStatus === 'LaidDeadHeat') && (betData.outputAmount-betData.cost < 0))"
            >{{betData.outputAmount-betData.cost| numberWithCommasAndCurrency(this.userCurrency)}}</span>
            <span v-if="betData.betStatus ==='Voided' || betData.betStatus ==='UserCanceled' || betData.betStatus ==='UnmatchedCanceled' || betData.betStatus ==='Refund'">{{0 | numberWithCommasAndCurrency(this.userCurrency)}}</span>
          </div>
        </div>
      </div>
      <div class="expanded-info" v-bind:class="{'expanded-info--active':shouldShowInfo}">
        <div class="expanded-info-bet-code">
          <div class="bet-code-title">
            <span>{{$t(`bets.settledBets.betCode`)| removeDiacriticsFromUppercase}}</span>
          </div>
          <div class="bet-code-value" @click="copyTextToClipboard(betData.orderId)">
            <span>{{betData.orderId}}</span>
            <div class="bet-code-copy">
              <v-icon>krypt-copy</v-icon>
            </div>
          </div>
        </div>
        <div class="expanded-info-time-stamp">
          <div class="time-stamp-title">
            <span>{{$t(`bets.settledBets.timeStamp`)| removeDiacriticsFromUppercase}}</span>
          </div>
          <div class="time-stamp">
            <span>{{getFormattedDate(betData.timeStamp)}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'settledBetCard',
  props: [
    'betData',
    'market'
  ],
  data: function () {
    return {
      shouldShowInfo: false
    };
  },
  computed:{
    userCurrency: function () {
      return this.$store.state.userCurrency;
    },
    betId:function () {
      return this.betData.id;
    }
  },
  watch:{
    betId:function () {
      this.shouldShowInfo = false;
    }
  },
  methods: {
    getFormattedDate:function(date){
      return new Intl.DateTimeFormat(window.SelectedTimeLocalisation,
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          // hour12:false,
          hourCycle: 'h23',
          minute: 'numeric',
          second: 'numeric'
        }
      ).format(new Date(date))
    },
    copyTextToClipboard: function (text) {
      let textArea = document.createElement('textarea');


      // Place in the top-left corner of screen regardless of scroll position.
      textArea.style.position = 'fixed';
      textArea.style.top = 0;
      textArea.style.left = 0;

      // Ensure it has a small width and height. Setting to 1px / 1em
      // doesn't work as this gives a negative w/h on some browsers.
      textArea.style.width = '2em';
      textArea.style.height = '2em';

      // We don't need padding, reducing the size if it does flash render.
      textArea.style.padding = 0;

      // Clean up any borders.
      textArea.style.border = 'none';
      textArea.style.outline = 'none';
      textArea.style.boxShadow = 'none';

      // Avoid flash of the white box if rendered for any reason.
      textArea.style.background = 'transparent';

      textArea.value = text;

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.log('Copying text command was ' + msg);
      } catch (err) {
        console.log('Oops, unable to copy');
      }

      document.body.removeChild(textArea);
    },

    showInfo: function () {
      this.shouldShowInfo = !this.shouldShowInfo;
    }
  }
}
;
</script>

<style scoped>
  .settled-bet-card {
    display: flex;
    border-bottom: 1px solid var(--grey-200);
    border-right: 1px solid var(--grey-200);
    border-top: 1px solid var(--grey-200);
    border-radius: 6px;
    margin-top: 8px;
  }

  .settled-bet-card-status-bar {
    display: flex;
    width: 4px;
    border-bottom-left-radius: 4px;
    border-top-left-radius: 4px;
  }

  .settled-bet-card-status-bar--won {
    background-color: var(--aquaman);
  }

  .settled-bet-card-status-bar--lost {
    background-color: var(--cyborg);
  }
  .settled-bet-card-status-bar--cancelled {
    background-color: var(--grey-400);
  }
  .settled-bet-card-content {
    display: flex;
    flex-direction: column;
    width: calc(100% - 4px);
  }

  .result-wrapper {
    display: flex;
    width: 100%;
    border-bottom: 1px solid var(--grey-200);
    padding: 0 8px;
  }

  .result-container{
    display: flex;
    margin-right: auto;
    padding: 8px 0px;
  }

  .result-title {
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: var(--grey-500);
    margin-right: 6px;
  }

  .result {
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    align-items: center;
    color: var(--grey-900);
  }

  .info-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 8px;
    margin-top: 4px;
    margin-bottom: 4px;
  }

  .info-btn > .v-icon {
    font-size: 24px;
    color: var(--grey-400);
    cursor: pointer;
  }

  .info-btn:hover > .v-icon {
    color: var(--grey-600);
  }

  .settled-bet-card-cells {
    display: flex;
    width: 100%;
    padding: 8px 4px;
  }

  .settled-bet-card-cell {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    padding: 0 4px;
    overflow: hidden;
  }

  .bet-card-cell-odds {
    max-width: 88px;
  }

  .cell-title {
    display: flex;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .cell-title > span {
    font-weight: bold;
    font-size: 10px;
    line-height: 14px;
    text-transform: uppercase;
    color: var(--grey-600);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .cell-title--won > span {
    color: var(--aquaman);
  }

  .cell-title--lost > span {
    color: var(--cyborg);
  }

  .cell-value {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: var(--grey-100);
    border-radius: 6px;
  }

  .cell-value > span {
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    align-items: center;
    text-align: center;
    color: var(--grey-900);
    border: 1px solid var(--grey-100);
    padding: 5px 4px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .expanded-info {
    display: flex;
    flex-direction: column;
    padding: 0px 8px;
    max-height: 0px;
    clip-path: inset(0);
    transition: all 0.35s ease-in-out;
    overflow: hidden;
  }

  .expanded-info--active {
    padding-bottom: 8px;
    max-height: 115px;
  }

  .expanded-info-bet-code {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-bottom: 8px;
  }

  .expanded-info-time-stamp {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .bet-code-title, .time-stamp-title {
    font-weight: bold;
    font-size: 10px;
    line-height: 14px;
    display: flex;
    align-items: center;
    color: var(--grey-600);
    padding-bottom: 1px;
    text-transform: uppercase;
  }

  .bet-code-value, .time-stamp {
    display: flex;
    align-items: center;
    padding: 8px 8px;
    background-color: var(--grey-100);
    border-radius: 6px;
    border: 1px solid var(--grey-100);
  }

  .bet-code-value > span, .time-stamp > span {
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    margin-right: auto;
    display: flex;
    align-items: center;
    color: var(--grey-900);
  }

  .bet-code-copy {
    display: flex;
    margin-top: -4px;
    margin-bottom: -4px;
  }

  .bet-code-copy > .v-icon {
    color: var(--grey-400);
    font-size: 24px;
    cursor: pointer;
  }

  .bet-code-copy:hover > .v-icon {
    color: var(--grey-600);
  }

</style>
